import { Event, Image } from '@tribeplatform/gql-client/types'

import { ActionButtons } from './ActionButtons.js'
import { HostedBy } from './HostedBy.js'

interface Props {
  event: Event
}

export const LeftSideColumn = ({ event }: Props) => {
  const imageUrl = (event.thumbnail as Image)?.url
  return (
    <div className="relative h-full sm:bg-surface-subdued rounded-s-base">
      <div className="p-4 sm:p-6 flex flex-col gap-y-4 sticky top-0">
        {imageUrl && (
          <div
            className="bg-cover bg-center rounded-base aspect-square"
            style={{
              backgroundImage: `url(${imageUrl})`,
            }}
          />
        )}
        <div className="hidden sm:flex p-4 border border-line rounded-base shadow-xs">
          <ActionButtons event={event} />
        </div>
        <HostedBy hosts={event.hosts} />
      </div>
    </div>
  )
}
